import { FC } from 'react';

import './style.css';

const NavDivider: FC = () => {
    return (
        <div className="nav_divider"></div>
    );
};

export default NavDivider;